export enum TableEnum {
  ServiceDeployments = 'ServiceDeployments',
  ServiceDeploymentTasks = 'ServiceDeploymentTasks',
  ServiceDeploymentTaskLocation = 'ServiceDeploymentTaskLocation',
}
